import {Box, BoxProps, Text} from '@chakra-ui/react';
import React, {FC} from 'react';

import {colors} from '../../../theme';

interface DiscountLabelProps extends BoxProps {
  oldPrice?: number;
  price?: number;
}

const DiscountLabel: FC<DiscountLabelProps> = ({oldPrice, price, ...boxProps}) => {
  const discount = calcDiscountPercent(oldPrice, price);

  if (!discount) return null;
  return (
    <Box
      position="absolute"
      bottom="8px"
      left="8px"
      zIndex={1}
      rounded="full"
      bg={colors.darkCharcoal}
      paddingX={2}
      {...boxProps}
    >
      <Text fontSize={12} textColor={colors.white}>
        {`-${discount}%`}
      </Text>
    </Box>
  );
};

function calcDiscountPercent(oldPrice?: number, price?: number): number | null {
  if (!oldPrice || !price || oldPrice <= 0) return null;
  const diff = oldPrice - price;
  if (diff <= 0) return null;
  return Math.round((diff / oldPrice) * 100);
}

export default DiscountLabel;
